import Button from "@mui/material/Button";
import isEmpty from "lodash/isEmpty";
import { useMemo } from "react";
import { useFormState } from "react-final-form";

const RffSubmitButton = ({
  onSubmit,
  loading,
  children,
  variant,
  disabled,
  size = "large",
  hideIfEmpty,
  startIcon,
  endIcon,
  sx,
}) => {
  const { values } = useFormState();

  const valuesEmpty = useMemo(() => {
    return isEmpty(values);
  }, [values]);

  const hideButton = useMemo(() => {
    if (hideIfEmpty && valuesEmpty) {
      return true;
    }
    return false;
  }, [valuesEmpty, hideIfEmpty]);

  if (hideButton) {
    return null;
  }

  return (
    <Button
      type="submit"
      // type="button"
      //
      startIcon={startIcon}
      endIcon={endIcon}
      loading={loading}
      variant={variant}
      size={size}
      disabled={valuesEmpty || disabled}
      sx={sx}
      // onClick={() => onSubmit(values)}
    >
      {children}
    </Button>
  );
};

export default RffSubmitButton;
